<template>
  <div class="row" :id="'vue-form-'+id">
    <form :data-vv-scope="name"
          :id="name+'_form'"
          ref="formRef"
          @submit.prevent="submit"
          class="loading"
          novalidate
          :is="formType"
    >
      <div class="main-vueform col-md-12">
        <div class="row">
          <div v-for="opt in schema" :key="opt.name" :class="'col-md-' + opt.grid">
            <field-render-wrapper
              v-if="opt.type !== 'accordion'"
              v-model="formData[opt.name]"
              v-show="!isFieldHidden(opt)"
              :ref="opt.name"
              :field="opt"
              :required="isFieldRequired(opt)"
              :locked="isFieldLocked(opt)"
              :form="formPreviews && formPreviews[opt.name] || {}"
              :hidden-values="hideValues"
              :programs="programs"
              :is-participant-submission="isParticipantSubmission"
              :referral-destination-accounts="referralDestinationAccounts"
              @force-rerender="forceRerender"
            />
            <!-- ACCORDION -->
            <ul v-if="opt.type === 'accordion'" v-show="!isFieldHidden(opt)" class="list-group accordion">
              <li class="list-group-item">
                <collapse :selected="false">
                  <div class="collapsible-header" slot="collapsible-header">
                    <b>{{ opt.description }}&nbsp; <i class="pull-right fa"></i></b>
                  </div>
                  <div class="collapsible-body" slot="collapsible-body">
                    <div v-for="accordionField in opt.values" :key="accordionField.name" :class="'col-md-' + accordionField.grid">
                      <!-- TODO: reduce duplication here -->
                      <field-render-wrapper
                        v-if="accordionField.type !== 'accordion'"
                        v-model="formData[accordionField.name]"
                        v-show="!isFieldHidden(accordionField)"
                        :ref="accordionField.name"
                        :field="accordionField"
                        :required="isFieldRequired(accordionField)"
                        :locked="isFieldLocked(accordionField)"
                        :form="formPreviews && formPreviews[opt.name] || {}"
                        :hidden-values="hideValues"
                        :programs="programs"
                        :is-participant-submission="isParticipantSubmission"
                        :referral-destination-accounts="referralDestinationAccounts"
                        @force-rerender="forceRerender"
                      />
                    </div>
                    <div class="clearfix"/>
                  </div>
                </collapse>
              </li>
            </ul>
          </div>
        </div><!-- row -->
      </div>
    </form>
  </div>
</template>

<script>
import Collapse from '@/components/Collapse';
import {mapGetters} from 'vuex';
import _ from 'lodash';
import updateCheckboxConditions from "../../mixins/formRender/updateCheckboxConditions";
import requiredFieldConditions from "../../mixins/formRender/requiredFieldConditions";
import showHideFieldConditions from "../../mixins/formRender/showHideFieldConditions";
import calculationsConditions from "../../mixins/formRender/calculationsConditions";
import getType from "../../mixins/formRender/reusable/getType";
import { DATE_TYPE } from "../../enums/dateType";
import FieldRenderWrapper from "./render/FieldRenderWrapper";


export default {
  name: 'vue-form-render',
  mixins: [
    requiredFieldConditions,
    updateCheckboxConditions,
    showHideFieldConditions,
    calculationsConditions,
    getType
  ],
  components: {
    FieldRenderWrapper,
    Collapse,
  },
  props: [
    'schema',
    'hideValues',
    'systemConditions',
    'calculations',
    'values',
    'name',
    'customFields',
    'lockform',
    'formblock',
    'noform',
    'map',
    'latestDismissedAssignment',
    // TODO: move to vuex
    'programs',
    'dateFormat',
    'userAccessLevel',
    // TODO: move to vuex
    'referralDestinationAccounts',
    'validationConditions',
    'isParticipantSubmission',
    // TODO: move to vuex
    'formPreviews'
  ],
  data() {
    return {
      files: [],
      formData: {},
      block: false,
      formType: 'form',
      id: Math.random().toString(36).substring(7),
      formFiles: this.values,
      radiosValues: {},
      allowDismissedProgramModification: this.latestDismissedAssignment === true && this.userAccessLevel > 3,
      lockedFields: [],
    }
  },

  computed: {
    ...mapGetters([
      'getErrors'
    ]),
    fieldByName: function () {
      const results = {};
      this.flatFieldList.forEach(f => {
        results[f.name] = f;
      })
      return results;
    },
    flatFieldList: function () {
      let fields = [];

      this.schema.forEach(field => {
        if (field.type === 'accordion') {
          fields.push(...field.values)
        } else {
          fields.push(field)
        }
      })

      return fields;
    },
    programStatus() {
      if (this.systemConditions && this.systemConditions.hasOwnProperty('programStatus')) {
        return this.systemConditions.programStatus.field;
      }
      return '';
    },
  },

  watch: {
    getErrors: function () {
      this.renderErrors();
    },
    formBlock: function (newVal) {
      this.lockedFields = newVal;
    },
    values: function (newValues) {
      this.formData = this.parseFormData(newValues, this.flatFieldList);
    },
    formData: {
      handler: _.debounce(function() {
        this.renderCalcsAndConditions()
      }, 100),
      deep: true
    },
    // schema: {
    //   handler: _.debounce(function() {
    //     console.log('schema')
    //     this.renderCalcsAndConditions()
    //   }, 100),
    //   deep: true
    // },
  },

  created() {
    if (this.formblock) {
      this.lockedFields = this.formblock;
    }

    // TODO: check this
    if (this.noform != null) {
      this.formType = 'div';
    }

    this.errors.clear(this.name);
    this.errors.clear(null);
  },

  mounted() {
    this.formData = this.parseFormData(this.values, this.flatFieldList);
  },

  methods: {
    forceRerender() {
      this.$forceUpdate();
    },
    addFormError(fieldName, msg) {
      let field = this.$validator.fields.find({name: fieldName, scope: null});

      if (!field) {
        field = this.$validator.attach({
          name: fieldName,
          scope: null
        });
      }

      this.$validator.errors.add({
        id: field.id,
        field: this.name + '.' + fieldName,
        msg: msg,
        scope: null
      });

      field.setFlags({
        invalid: true,
        valid: false,
        validated: true,
      });
    },

    // TODO: this method calls has been removed, update it to more declarative approach
    renderCalcsAndConditions() {
      this.renderCalculations();
      this.renderRequiredConditions();
      this.renderShowHideFieldConditions();
      this.renderAllUpdateConditions();

      // XXX: update conditions are not working properly without this
      this.$forceUpdate();
    },

    validateAll() {
      const validationPromises = this.flatFieldList
        .filter(f => f.type !== 'accordion')
        .map(field => {
          return this.$refs[field.name][0].validate();
        });
      return Promise.all(validationPromises);
    },


    submit() {
      // TODO: check these lines
      // TODO: add slot for placing submit buttons within this component and pass submit as slot property
      this.errors.clear('tab_assignment');
      this.errors.clear(this.name);
      this.errors.clear(null);

      return this.validateAll().then((result) => {
        // validateAll return arrays of boolean holding results for each field validation
        const results = {isValid: result.every(r => r)}

        if (results.isValid) {
          Object.assign(results, this.serializeFormData(this.formData, this.flatFieldList));
        } else {
          // TODO: handle this in form
          this.$emit('validation-failed', true);
        }

        return results;
      })
    },

    renderErrors() {
      this.errors.clear('tab_assignment');
      Object.keys(this.getErrors).forEach(obj => {
        this.addFormError(obj, this.getErrors[obj]);
      });
    },

    /**
     * Convert data received from backend to format used for form display
     * @param formData
     * @param fieldList
     */
    parseFormData(formData, fieldList) {
      const results = {};

      if (formData) {
        // iterate over fields
        fieldList.forEach(field => {
          // check if it's shared field
          const fieldType = field.type === 'shared-field' ? field.displayType : field.type;

          // checkbox groups are stored differently
          if (!fieldType.includes('checkbox-group')) {
            // get value for given field
            const value = formData[field.name]

            // don't parse null values
            if (value !== '' && value !== null && !Number.isNaN(value) && typeof value !== 'undefined') {
              switch(fieldType) {
                case 'file':
                  results[field.name] = JSON.parse(value);
                  break;
                case 'number':
                case 'select_case_manager_secondary':
                case 'select2':
                  results[field.name] = Number(value)
                  break;
                default:
                  results[field.name] = value
              }
            }
          } else {
            // each value is stored separately as key: `checkbox-group-<id>-<option index>`
            results[field.name] = Object.keys(formData)
              .filter(f => f.startsWith(field.name))
              .map(f => formData[f])
          }
        })
      }

      return results;
    },

    /**
     * Convert form data to backend format used for form submission
     * @param formData
     * @param fieldList
     */
    serializeFormData(formData, fieldList) {
      const fields = [];
      const files = [];

      // iterate over fields
      fieldList.forEach(field => {
        // get value for given field
        const value = formData[field.name]
        let serializedValue;

        // check if it's shared field
        const fieldType = field.type === 'shared-field' ? field.displayType : field.type;

        if (typeof value !== 'undefined'){
          // checkbox groups are stored differently
          if (!fieldType.includes('checkbox-group')) {
            switch(fieldType) {
              case 'file':
                // already uploaded files are passed under regular field value in form of {name: ..., file: ...} objects
                // newly uploaded file are send as file attachment to form data
                const existingFiles = [];

                value.forEach(f => {
                  if (f.fileObject) {
                    files.push({
                      field: field.name,
                      file: f.file,
                      filename: f.file.name
                    })
                  } else {
                    existingFiles.push(f);
                  }
                })
                serializedValue = JSON.stringify(existingFiles);
                break;
              case 'date':
                serializedValue = moment(value, this.dateFormat).format(DATE_TYPE.BACKEND);
                break;
              case 'number':
              case 'select_case_manager_secondary':
              case 'select2':
                serializedValue = value.toString();
                break;
              default:
                serializedValue = value
            }
            fields.push({name: field.name, value: serializedValue});
          } else {
            // each value is stored separately as key: `[programs]-checkbox-group-<id>-<option index>`
            let indexLookup;
            if (field.name.startsWith('programs')) {
              indexLookup = (query) => this.programs.findIndex(value => value.id.toString() === query)
            } else {
              indexLookup = (query) => field.values.findIndex(value => value.label === query)
            }

            value.forEach(optionLabel => {
              const index = indexLookup(optionLabel);
              fields.push({name: `${field.name}-${index}`, value: optionLabel});
            })
          }
        }
      })

      return {
        fields,
        files
      };
    },
    isFieldLocked(field) {
      if (this.lockform || this.lockedFields.includes(field.name)) return true;

      // TODO: find better place for this
      if (field.type === 'select') {
        return field.name === this.programStatus &&
          this.$route.name === 'Participant History'
          && !this.allowDismissedProgramModification
      }
    }
  },
  inject: {
    $validator: '$validator'
  },
}
</script>

<style>
label.disabled {
  color: #E4E4E4;
}

input[type='date'] {
  text-transform: uppercase;
}

.accordion .list-group-item {
  border-color: #d09f23;
  padding: 0px;
}

.accordion .collapses.is-active .collapsible-header {
  border-bottom: 1px solid #d09f23;
}

.accordion .collapsible-header {
  color: #FFFFFF;
  background-color: #d09f23;
  border-color: #d09f23;
  padding: 10px 15px;
}

.accordion .collapsible-header b {
  font-size: 16px;
  font-weight: 300;
}

.accordion .collapse-content {
  padding: 15px 20px;
}

.mt-checkbox-list, .mt-radio-list {
  padding: 0px;
}

.control-label {
  margin-bottom: 10px;
}

.ql-align-center {
  text-align: center;
}

.ql-align-justify {
  text-align: justify;
}

.ql-align-right {
  text-align: right;
}

</style>



// WEBPACK FOOTER //
// VueFormRender.vue?4e4fda22